import Accordion from "../components/Accordion";

import informe_2025 from "../docs/lotaip/2025/informe.pdf"
function Lotaip2025() {
  return (
    <>
      <Accordion
        title="LOTAIP 2025"
        content={
          <>

          <a href={informe_2025}>Informe anual 2025</a>
          <br></br>
            {/* <Accordion
              title="Enero"
              content={
                <div className="section-acc">
                  <Accordion
                    title="1.1 Estructura orgánica"
                    content={
                      <>
                        <a href={enero_estructura_datos}>Conjunto de datos</a>
                        <a href={enero_estructura_metadatos}>Metadatos</a>
                        <a href={enero_estructura_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="1.2 Base legal regulaciones procedimientos internos"
                    content={
                      <>
                        <a href={enero_base_datos}>Conjunto de datos</a>
                        <a href={enero_base_metadatos}>Metadatos</a>
                        <a href={enero_base_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="1.3 Metas y objetivos"
                    content={
                      <>
                        <a href={enero_metas_datos}>Conjunto de datos</a>
                        <a href={enero_metas_metadatos}>Metadatos</a>
                        <a href={enero_metas_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="2. Directorio y distributivo personal de la entidad"
                    content={
                      <>
                        <a href={enero_directorio_datos}>Conjunto de datos</a>
                        <a href={enero_directorio_metadatos}>Metadatos</a>
                        <a href={enero_directorio_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="3. Remuneraciones ingresos adicionales"
                    content={
                      <>
                        <a href={enero_remuneraciones_datos}>
                          Conjunto de datos
                        </a>
                        <a href={enero_remuneraciones_metadatos}>Metadatos</a>
                        <a href={enero_remuneraciones_diccionario}>
                          Diccionario
                        </a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="5-22 Servicios-formularios-formatos-trámites"
                    content={
                      <>
                        <a href={enero_servicios_datos}>Conjunto de datos</a>
                        <a href={enero_servicios_metadatos}>Metadatos</a>
                        <a href={enero_servicios_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="6. Presupuesto de la institucion"
                    content={
                      <>
                        <a href={enero_presupuesto_datos}>Conjunto de datos</a>
                        <a href={enero_presupuesto_metadatos}>Metadatos</a>
                        <a href={enero_presupuesto_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="10. Planes y programas"
                    content={
                      <>
                        <a href={enero_planes_datos}>Conjunto de datos</a>
                        <a href={enero_planes_metadatos}>Metadatos</a>
                        <a href={enero_planes_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="12. Mecanismos rendicion cuentas"
                    content={
                      <>
                        <a href={enero_mecanismo_datos}>Conjunto de datos</a>
                        <a href={enero_mecanismo_metadatos}>Metadatos</a>
                        <a href={enero_mecanismo_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="14. Responsables del acceso de informacion publica"
                    content={
                      <>
                        <a href={enero_responsables_datos}>Conjunto de datos</a>
                        <a href={enero_responsables_metadatos}>Metadatos</a>
                        <a href={enero_responsables_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="15. Texto integro de los contratos colectivos vigentes y reformas"
                    content={
                      <>
                        <a href={enero_texto_datos}>Conjunto de datos</a>
                        <a href={enero_texto_metadatos}>Metadatos</a>
                        <a href={enero_texto_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                </div>
              }
            ></Accordion>

            <Accordion
              title="Febrero"
              content={
                <div className="section-acc">
                  <Accordion
                    title="1.1 Estructura orgánica"
                    content={
                      <>
                        <a href={febrero_estructura_datos}>Conjunto de datos</a>
                        <a href={febrero_estructura_metadatos}>Metadatos</a>
                        <a href={febrero_estructura_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="1.2 Base legal regulaciones procedimientos internos"
                    content={
                      <>
                        <a href={febrero_base_datos}>Conjunto de datos</a>
                        <a href={febrero_base_metadatos}>Metadatos</a>
                        <a href={febrero_base_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="1.3 Metas y objetivos"
                    content={
                      <>
                        <a href={febrero_metas_datos}>Conjunto de datos</a>
                        <a href={febrero_metas_metadatos}>Metadatos</a>
                        <a href={febrero_metas_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="2. Directorio y distributivo personal de la entidad"
                    content={
                      <>
                        <a href={febrero_directorio_datos}>Conjunto de datos</a>
                        <a href={febrero_directorio_metadatos}>Metadatos</a>
                        <a href={febrero_directorio_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="3. Remuneraciones ingresos adicionales"
                    content={
                      <>
                        <a href={febrero_remuneraciones_datos}>
                          Conjunto de datos
                        </a>
                        <a href={febrero_remuneraciones_metadatos}>Metadatos</a>
                        <a href={febrero_remuneraciones_diccionario}>
                          Diccionario
                        </a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="5-22 Servicios-formularios-formatos-trámites"
                    content={
                      <>
                        <a href={febrero_servicios_datos}>Conjunto de datos</a>
                        <a href={febrero_servicios_metadatos}>Metadatos</a>
                        <a href={febrero_servicios_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="6. Presupuesto de la institucion"
                    content={
                      <>
                        <a href={febrero_presupuesto_datos}>
                          Conjunto de datos
                        </a>
                        <a href={febrero_presupuesto_metadatos}>Metadatos</a>
                        <a href={febrero_presupuesto_diccionario}>
                          Diccionario
                        </a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="10. Planes y programas"
                    content={
                      <>
                        <a href={febrero_planes_datos}>Conjunto de datos</a>
                        <a href={febrero_planes_metadatos}>Metadatos</a>
                        <a href={febrero_planes_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="12. Mecanismos rendicion cuentas"
                    content={
                      <>
                        <a href={febrero_mecanismo_datos}>Conjunto de datos</a>
                        <a href={febrero_mecanismo_metadatos}>Metadatos</a>
                        <a href={febrero_mecanismo_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="14. Responsables del acceso de informacion publica"
                    content={
                      <>
                        <a href={febrero_responsables_datos}>
                          Conjunto de datos
                        </a>
                        <a href={febrero_responsables_metadatos}>Metadatos</a>
                        <a href={febrero_responsables_diccionario}>
                          Diccionario
                        </a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="15. Texto integro de los contratos colectivos vigentes y reformas"
                    content={
                      <>
                        <a href={febrero_texto_datos}>Conjunto de datos</a>
                        <a href={febrero_texto_metadatos}>Metadatos</a>
                        <a href={febrero_texto_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                </div>
              }
            ></Accordion>

            <Accordion
              title="Marzo"
              content={
                <div className="section-acc">
                  <Accordion
                    title="1.1 Estructura orgánica"
                    content={
                      <>
                        <a href={marzo_estructura_datos}>Conjunto de datos</a>
                        <a href={marzo_estructura_metadatos}>Metadatos</a>
                        <a href={marzo_estructura_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="1.2 Base legal regulaciones procedimientos internos"
                    content={
                      <>
                        <a href={marzo_base_datos}>Conjunto de datos</a>
                        <a href={marzo_base_metadatos}>Metadatos</a>
                        <a href={marzo_base_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="1.3 Metas y objetivos"
                    content={
                      <>
                        <a href={marzo_metas_datos}>Conjunto de datos</a>
                        <a href={marzo_metas_metadatos}>Metadatos</a>
                        <a href={marzo_metas_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="2. Directorio y distributivo personal de la entidad"
                    content={
                      <>
                        <a href={marzo_directorio_datos}>Conjunto de datos</a>
                        <a href={marzo_directorio_metadatos}>Metadatos</a>
                        <a href={marzo_directorio_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="3. Remuneraciones ingresos adicionales"
                    content={
                      <>
                        <a href={marzo_remuneraciones_datos}>
                          Conjunto de datos
                        </a>
                        <a href={marzo_remuneraciones_metadatos}>Metadatos</a>
                        <a href={marzo_remuneraciones_diccionario}>
                          Diccionario
                        </a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="5-22 Servicios-formularios-formatos-trámites"
                    content={
                      <>
                        <a href={marzo_servicios_datos}>Conjunto de datos</a>
                        <a href={marzo_servicios_metadatos}>Metadatos</a>
                        <a href={marzo_servicios_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="6. Presupuesto de la institucion"
                    content={
                      <>
                        <a href={marzo_presupuesto_datos}>Conjunto de datos</a>
                        <a href={marzo_presupuesto_metadatos}>Metadatos</a>
                        <a href={marzo_presupuesto_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="10. Planes y programas"
                    content={
                      <>
                        <a href={marzo_planes_datos}>Conjunto de datos</a>
                        <a href={marzo_planes_metadatos}>Metadatos</a>
                        <a href={marzo_planes_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="12. Mecanismos rendicion cuentas"
                    content={
                      <>
                        <a href={marzo_mecanismo_datos}>Conjunto de datos</a>
                        <a href={marzo_mecanismo_metadatos}>Metadatos</a>
                        <a href={marzo_mecanismo_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="14. Responsables del acceso de informacion publica"
                    content={
                      <>
                        <a href={marzo_responsables_datos}>Conjunto de datos</a>
                        <a href={marzo_responsables_metadatos}>Metadatos</a>
                        <a href={marzo_responsables_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="15. Texto integro de los contratos colectivos vigentes y reformas"
                    content={
                      <>
                        <a href={marzo_texto_datos}>Conjunto de datos</a>
                        <a href={marzo_texto_metadatos}>Metadatos</a>
                        <a href={marzo_texto_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                </div>
              }
            ></Accordion>

            <Accordion
              title="Abril"
              content={
                <>
                  <Accordion
                    title="1.1 Estructura orgánica"
                    content={
                      <>
                        <a href={abril_estructura_datos}>Conjunto de datos</a>
                        <a href={abril_estructura_metadatos}>Metadatos</a>
                        <a href={abril_estructura_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="1.2 Base legal regulaciones procedimientos internos"
                    content={
                      <>
                        <a href={abril_base_datos}>Conjunto de datos</a>
                        <a href={abril_base_metadatos}>Metadatos</a>
                        <a href={abril_base_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="1.3 Metas y objetivos"
                    content={
                      <>
                        <a href={abril_metas_datos}>Conjunto de datos</a>
                        <a href={abril_metas_metadatos}>Metadatos</a>
                        <a href={abril_metas_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="2. Directorio y distributivo personal de la entidad"
                    content={
                      <>
                        <a href={abril_directorio_datos}>Conjunto de datos</a>
                        <a href={abril_directorio_metadatos}>Metadatos</a>
                        <a href={abril_directorio_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="3. Remuneraciones ingresos adicionales"
                    content={
                      <>
                        <a href={abril_remuneraciones_datos}>
                          Conjunto de datos
                        </a>
                        <a href={abril_remuneraciones_metadatos}>Metadatos</a>
                        <a href={abril_remuneraciones_diccionario}>
                          Diccionario
                        </a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="5-22 Servicios-formularios-formatos-trámites"
                    content={
                      <>
                        <a href={abril_servicios_datos}>Conjunto de datos</a>
                        <a href={abril_servicios_metadatos}>Metadatos</a>
                        <a href={abril_servicios_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="6. Presupuesto de la institucion"
                    content={
                      <>
                        <a href={abril_presupuesto_datos}>Conjunto de datos</a>
                        <a href={abril_presupuesto_metadatos}>Metadatos</a>
                        <a href={abril_presupuesto_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>

                  <Accordion
                    title="10. Planes y programas"
                    content={
                      <>
                        <a href={abril_planes_datos}>Conjunto de datos</a>
                        <a href={abril_planes_metadatos}>Metadatos</a>
                        <a href={abril_planes_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="12. Mecanismos rendicion cuentas"
                    content={
                      <>
                        <a href={abril_mecanismo_datos}>Conjunto de datos</a>
                        <a href={abril_mecanismo_metadatos}>Metadatos</a>
                        <a href={abril_mecanismo_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="14. Responsables del acceso de informacion publica"
                    content={
                      <>
                        <a href={abril_responsables_datos}>Conjunto de datos</a>
                        <a href={abril_responsables_metadatos}>Metadatos</a>
                        <a href={abril_responsables_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                  <Accordion
                    title="15. Texto integro de los contratos colectivos vigentes y reformas"
                    content={
                      <>
                        <a href={abril_texto_datos}>Conjunto de datos</a>
                        <a href={abril_texto_metadatos}>Metadatos</a>
                        <a href={abril_texto_diccionario}>Diccionario</a>
                      </>
                    }
                  ></Accordion>
                </>
              }
            ></Accordion> */}
          </>
        }
      ></Accordion>
    </>
  );
}

export default Lotaip2025;
